import { Btn } from "@/shared/ui/btn";
import { Section } from "@/shared/ui/section";
import { Footer } from "@/widgets/footer";
import { Header } from "@/widgets/header";

/**
 * Error page
 * @returns {ReactNode}
 * @constructor
 */
export const Error = () => {
  return (
    <>
      <Header isDefaultBlurred={true} />
      <main className={"pageLayout__main bg-[var(--color-bege)]"}>
        <Section utilClasses={[ "mb-13 mobile:mb-8" ]} extraClasses={{ isPtLargeMobile: true }}>
          <div className={"flex flex-col flex-wrap justify-center content-center gap-8"}>
            <p className={"text-[12rem] tablet:text-[10rem] mobile:text-[8rem] font-bold leading-[1.1] w-max"}><span className={"isGradientText"}>404</span> <br />Not Found</p>
            <Btn as={"link"} href={"/"} typeStyle={"ghost"} className={" w-max"}><span className={"isGradientDarkText"}>Go to Homepage</span></Btn>
          </div>
        </Section>
      </main>
      <Footer />
    </>
  );
};
